export const titles = {
  home: "はじめに",

  teachers: "先生を登録",
  newTeacher: "先生新規登録",
  editTeacher: "先生更新",
  bulkRegisterTeachers: "先生一括登録",

  classes: "クラスを登録",
  newClass: "クラス新規登録",
  editClass: "クラス更新",
  bulkEditClasses: "クラス一括編集",

  students: "生徒を登録",
  cramSchoolStudents: "生徒を管理",
  newStudent: "生徒新規登録",
  editStudent: "生徒更新",
  bulkEditStudents: "生徒一括編集",
  useHistories: "プラン利用状況",

  exchangeSchoolYear: "年度更新",
  nextYearClasses: "クラスを登録", // (${nextYear}年度)
  newNextYearClass: "クラス新規登録", // (${nextYear}年度)
  editNextYearClass: "クラス更新", // (${nextYear}年度)
  bulkEditNextYearClasses: "クラス一括編集", // (${nextYear}年度)
  nextYearStudents: "生徒登録", // (${nextYear}年度)
  newNextYearStudent: "生徒新規登録", // (${nextYear}年度)
  bulkRegisterNextYearStudents: "生徒新規一括登録", // (${nextYear}年度)
  editNextYearStudent: "生徒更新", // (${nextYear}年度)
  bulkEditNextYearStudents: "生徒一括編集", // (${nextYear}年度)

  subjects: "教科を登録",
  subjectRegistration: "登録",
  studentPhotos: "生徒顔写真登録",

  gearStatus: "GEAR利用状況",

  subClasses: "グループの登録",
  newSubClass: "グループ作成・先生登録",
  editSubClass: "グループ編集・先生登録",
  editSubClassStudent: "グループ生徒登録",
  BulkRegisterStudents: "生徒新規一括登録",
  notifications: "お知らせの管理",
  newNotification: "お知らせ新規作成",
  editNotification: "お知らせ更新",
  copyNotification: "お知らせ複製",
};
